import type { IAxisCommonTheme } from '../../../../../component/axis';

export const axisLinear: IAxisCommonTheme = {
  domainLine: {
    visible: false
  },
  grid: {
    visible: true
  },
  subGrid: {
    visible: false
  },
  tick: {
    visible: false
  },
  subTick: {
    visible: false
  }
};
